// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Link-module--cls1--2Ds1_","cls2":"styles-Link-module--cls2--DUyaL styles-Link-module--cls1--2Ds1_"};